/**
 * FeedbackSubmitOverlay
 *
 * Full-screen loading overlay shown on `FeedbackPage` while the feedback save is
 * in flight. Ports Flutter's `_isSubmitting` layer: a dimmed backdrop covering
 * the content with a centered `ExpauseLoadingIndicator` that blocks interaction
 * (`in_app_feedback_screen.dart:266-280`).
 *
 * Co-located with `FeedbackPage` to keep the page under the ~200-line Should-Fix
 * threshold from `presentation.md`. UI deviates from Flutter per `presentation.md`:
 * Flutter swaps the whole body for the indicator; the web overlays it
 * (`position: fixed`, above sheet z-indices) per the established `AddRoadmapPage`
 * pattern.
 */
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { ExpauseLoadingIndicator } from '@/presentation/components/common/loadingIndicators/ExpauseLoadingIndicator';
import { qaAttr } from '@/presentation/utils/qaAttr';

/** z-index sitting above the sheet layer, matching the `AddRoadmapPage` overlay. */
const OVERLAY_Z_INDEX = 9999;

export const FeedbackSubmitOverlay = () => {
  const { theme } = useTheme();

  return (
    <div
      {...qaAttr({ id: 'feedback-submitting-overlay' })}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: theme.modalOverlay,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: OVERLAY_Z_INDEX,
      }}
    >
      <ExpauseLoadingIndicator />
    </div>
  );
};
